(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltex-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class VoltexHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.progressElement = this.querySelector('[data-progress]');
      this.currentLabel = this.querySelector('[data-current]');
      this.current = 0;
      this.total = this.slides.length;
      this.duration = parseInt(this.dataset.autoplay, 10) || 4000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = this.dataset.autoplayEnabled === 'true' && this.total > 1 && !this.reducedMotion;

      this.prevButton?.addEventListener('click', () => this.goTo(this.current - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.current + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

      if (this.autoplayEnabled) {
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());
        this.resume();
      }
    }

    disconnectedCallback() {
      this.pause();
    }

    goTo(index) {
      const next = (index + this.total) % this.total;
      if (next === this.current) return;

      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current]?.classList.remove('is-active');
      this.current = next;
      this.slides[this.current].classList.add('is-active');
      this.dots[this.current]?.classList.add('is-active');

      if (this.currentLabel) {
        this.currentLabel.textContent = String(this.current + 1).padStart(2, '0');
      }
      if (this.autoplayEnabled) this.resume();
    }

    pause() {
      clearTimeout(this.timer);
    }

    resume() {
      this.pause();
      if (!this.progressElement) {
        this.timer = setTimeout(() => this.goTo(this.current + 1), this.duration);
        return;
      }
      this.progressElement.style.transition = 'none';
      this.progressElement.style.width = '0%';
      requestAnimationFrame(() => {
        this.progressElement.style.transition = `width ${this.duration}ms linear`;
        this.progressElement.style.width = '100%';
      });
      this.timer = setTimeout(() => this.goTo(this.current + 1), this.duration);
    }
  }

  if (!customElements.get('voltex-hero-slideshow')) {
    customElements.define('voltex-hero-slideshow', VoltexHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltex-product-landing"] && !Shopify.designMode) return;
  try {
    
  function voltexInitProductLandings() {
    document.querySelectorAll('.voltex-pl').forEach((root) => {
      if (root.dataset.vplInitialized) return;
      root.dataset.vplInitialized = 'true';

      const mainImg = root.querySelector('[data-vpl-main-img]');
      root.querySelectorAll('[data-vpl-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (mainImg) mainImg.src = thumb.dataset.full;
          root.querySelectorAll('[data-vpl-thumb]').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const qtyInput = root.querySelector('[data-vpl-qty-input]');
      if (qtyInput) {
        root.querySelectorAll('[data-vpl-qty-minus]').forEach((btn) => {
          btn.addEventListener('click', () => {
            qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          });
        });
        root.querySelectorAll('[data-vpl-qty-plus]').forEach((btn) => {
          btn.addEventListener('click', () => {
            qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
          });
        });
      }

      root.querySelectorAll('[data-vpl-faq-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.vpl-faq');
          const isOpen = item.classList.contains('is-open');
          root.querySelectorAll('.vpl-faq').forEach((f) => f.classList.remove('is-open'));
          if (!isOpen) item.classList.add('is-open');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', voltexInitProductLandings);
  } else {
    voltexInitProductLandings();
  }
  document.addEventListener('shopify:section:load', voltexInitProductLandings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltex-testimonials"] && !Shopify.designMode) return;
  try {
    
  class VoltexTestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.current = 0;
      this.duration = parseInt(this.dataset.autoplay, 10) || 4000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = this.dataset.autoplayEnabled === 'true' && this.cards.length > 1 && !this.reducedMotion;

      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

      if (this.autoplayEnabled) {
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('touchstart', () => this.pause(), { passive: true });
        this.resume();
      }
    }

    disconnectedCallback() {
      this.pause();
    }

    goTo(index) {
      this.current = (index + this.cards.length) % this.cards.length;
      const card = this.cards[this.current];
      this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
      if (this.autoplayEnabled) this.resume();
    }

    pause() {
      clearInterval(this.timer);
    }

    resume() {
      this.pause();
      this.timer = setInterval(() => this.goTo(this.current + 1), this.duration);
    }
  }

  if (!customElements.get('voltex-testimonial-carousel')) {
    customElements.define('voltex-testimonial-carousel', VoltexTestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltex-urgency"] && !Shopify.designMode) return;
  try {
    
  class VoltexUrgency extends HTMLElement {}

  function voltexInitUrgencyBars() {
    document.querySelectorAll('.voltex-urgency[data-end-datetime]').forEach((bar) => {
      if (bar.dataset.voltexInitialized) return;
      bar.dataset.voltexInitialized = 'true';

      const endTime = new Date(bar.dataset.endDatetime).getTime();
      if (Number.isNaN(endTime)) return;

      const daysEl = bar.querySelector('[data-days]');
      const hoursEl = bar.querySelector('[data-hours]');
      const minutesEl = bar.querySelector('[data-minutes]');
      const secondsEl = bar.querySelector('[data-seconds]');

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          bar.hidden = true;
          clearInterval(interval);
          return;
        }
        bar.hidden = false;
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      const interval = setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', voltexInitUrgencyBars);
  } else {
    voltexInitUrgencyBars();
  }

  } catch(e) { console.error(e); }
})();
})();
